module.exports = __webpack_public_path__ + "static/media/ios-flag.5b62c93f.svg";